import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from '../../assets/svg/chevronLeft';
import ChevronRight from '../../assets/svg/chevronRight';
import './PageControl.css';

const PageControl = ({ activePage, totalNumberOfPages, onPrevious, onNext }) => {
  const showPreviousButton = activePage > 0;
  const showNextButton = activePage + 1 < totalNumberOfPages;

  return (
    <div className='flex-1 flex-rows' style={{ justifyContent: 'center', marginTop: 16 }}>
      <div className='chevronContainer chevronContainerLeft' onClick={showPreviousButton ? onPrevious : null}>
        { showPreviousButton ? <ChevronLeft /> : null }
      </div>
      <h2>{activePage + 1} / {totalNumberOfPages}</h2>
      <div className='chevronContainer chevronContainerRight' onClick={showNextButton ? onNext : null}>
        { showNextButton ? <ChevronRight /> : null }
      </div>
    </div>
  );
};

PageControl.propTypes = {
  activePage: PropTypes.number,
  totalNumberOfPages: PropTypes.number,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func
};

export default PageControl;
